// Module
var code = "<div> <p>{{ successMessage }}</p> </div> ";
// Exports
module.exports = code;